import {Component} from "react";
import simplyContext from "../state/simply";

class Preloader extends Component {
    static contextType = simplyContext

    render() {
        return (
            <div
                className={this.context.state.sPreloader === true ? 'position-fixed w-100 min-vh-100 top-0 start-0 d-flex align-items-center justify-content-center cZindex9999 cBg1' : "d-none"}>
                <div className='row'>
                    <div className='col-12 text-center'>
                        <div className="dot-spinner">
                            <div className="dot-spinner__dot"></div>
                            <div className="dot-spinner__dot"></div>
                            <div className="dot-spinner__dot"></div>
                            <div className="dot-spinner__dot"></div>
                            <div className="dot-spinner__dot"></div>
                            <div className="dot-spinner__dot"></div>
                            <div className="dot-spinner__dot"></div>
                            <div className="dot-spinner__dot"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Preloader